import MeddiGrid from '../MeddiGrid/MeddiGrid';
import LekovyZaznamListItem from './LekovyZaznamListItem';
import Text from '../Base/Text/Text';

export default function LekovyZaznamList() {
	return (
		<>
			<Text tx='asd' />
			<MeddiGrid
				template={item => <LekovyZaznamListItem {...item} />}
				items={[
					{
						title: 'title 2',
					},
				]}
			/>
		</>
	);
}
